module.exports = __webpack_public_path__ + "6f95cc66734ebfbb6363579431290216.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/mythos-3.jpg
// module id = 527
// module chunks = 0